<template>
    <div class="VestList">
       <div>
           <el-button type="primary" @click="createvest()">新建马甲</el-button>
           <section class="startMgt-header">
               <el-input placeholder="马甲名称" v-model="dataapi.name" style="width: 240px"></el-input>
               <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
           </section>
       </div>
        <!-- end 顶部菜单栏 -->
        <section>
            <el-table :data="vestData">
                <el-table-column prop="innerid" label="马甲ID" align="left"></el-table-column>

                <el-table-column prop="subjectcount" label="马甲名称" align="center">
                    <template slot-scope="scope">
                        <div class="customerBox">
                            <img :src="scope.row.headlogourl">
                            <span class="recommon">{{scope.row.name}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center"></el-table-column>
                <el-table-column label="操作" align="right">
                    <template slot-scope="scope">
                        <div class="position">
                            <p @click="createvest(scope.row.innerid)">编辑</p>
                            <span>|</span>
                            <p @click="delvest(scope.row.innerid)">删除</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!--<page :total="total" ref="page" @getList="searchClick"></page>-->
            <el-pagination style="margin-top: 20px"
                background
                layout="prev, pager, next"
                :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPage">
            </el-pagination>

        </section>
    </div>
</template>

<script>
    import { findStarsockpuppetList, deleteStarsockpuppet } from 'api/communityApi'
    import { mapActions } from 'vuex'

    export default {
        name: "VestList",
        props: ['innerid'],
        data() {
            return {
                rowCount: 0,
                vestData: [],
                currentPage: 1,     // 初始化页数
                dataapi: {
                    name: '',
                    starinnerid: this.innerid,
                    page: 1,
                    pageSize: 10
                }
            }
        },
        mounted() {
            this.vestinfo(1)
        },
        methods: {
            vestinfo(page) {

                this.setLoading(true)
                this.dataapi.page = page

                findStarsockpuppetList({
                    data: this.dataapi,
                    success: data => {
                        console.log('list',data.data)
                        this.vestData = data.data.content
                        // 页数设置
                        this.rowCount = data.data.pageinfo.rowCount
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })

            },
            fPage() {
                let clickPage = $(".el-pagination .active").html()
                this.apiData.page = clickPage
                this.vestinfo(clickPage)
            },
            handleQuery() {
                this.vestinfo(1)
            },
            createvest(starid) {
                if (starid) {
                    this.$router.push({name: 'CreateVest',query: {'starid': starid, 'innerid': this.innerid}})
                } else {
                    console.log(this.innerid)
                    this.$router.push({name: 'CreateVest',query: {'innerid': this.innerid}})
                }
                //
            },
            delvest(starid) {
                // 删除马甲
                let delapi = {
                    starinnerid: this.innerid,
                    innerid: starid
                }
                this.$confirm('确定要删除马甲吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.setLoading(true)
                    deleteStarsockpuppet({
                        data: delapi,
                        success: data => {
                            this.setLoading(false)
                            this.$message.success('删除成功')
                            this.vestinfo(1)
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(()=>{})
            },
            ...mapActions([
                'setLoading'
            ]),
        },
        components: {
        }
    }

</script>

<style lang="scss" type="text/scss">
    .VestList {
        .startMgt-header {
            float: right;
            width: 40%;
            height: 40px;
            margin-bottom: 12px;
            .el-input__icon {
                height: 36px;
                line-height: 0 !important;
            }
            .el-select, .el-select > .el-input, .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select, .el-input {
                margin-right: 20px;
            }
        }

        .customerBox {
            display: flex;
            align-items: center;
            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
            .manger {
                width: 50px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                color: #fff;
                font-size: 12px;
                background: rgba(230, 162, 60, 1);
                border-radius: 2px;
                position: absolute;
                bottom: 10px;
            }
        }

        .table-position {
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            span {
                color: #409EFF;
                cursor: pointer;
            }
        }
        .position p,
        .position span,
        .el-dropdown-link {
            color: #409EFF;
        }
        .position p,
        .position span {
            display: inline-block;
            margin-left: 5px;
            cursor: pointer;
        }

    }

</style>
